/**
 * Curated brand assets (logo, hero, about morph, exclusives process video).
 * Live product data comes from Supabase via /src/lib/supabase.js.
 *
 * Each Supabase row is normalized to the shape the UI components already use
 * (priceInr camelCase, uppercase category, etc.) so we don't have to refactor
 * every component in lockstep with the DB migration.
 */
const CDN = "https://customer-assets.emergentagent.com/job_raw-culture-1/artifacts";

// New barbed-wire Damage Culture logo (2026-05). Two variants on transparent PNG:
//   LOGO_DARK  -> ink/black on light backgrounds (top nav on solid cream)
//   LOGO_LIGHT -> cream/white on dark backgrounds (transparent hero, dark menu, footer)
// Components should pick the variant based on the surface behind it.
export const LOGO_DARK = "/assets/dc-logo-dark.png";
export const LOGO_LIGHT = "/assets/dc-logo-white.png";
// Back-compat: default export still works for any place that imports LOGO_URL.
export const LOGO_URL = LOGO_DARK;
export const HERO_IMAGE = `${CDN}/udyw6x55_Image.png`;
export const PROCESS_VIDEO = "/assets/process.mp4";
export const PROCESS_POSTER = "/assets/process_poster.jpg";

export const SIZES = ["S", "M", "L", "XL"];

export const ABOUT_MORPH_IMAGES = [
  `${CDN}/m022nitx_Screenshot%202026-05-19%20at%209.54.21%E2%80%AFPM.png`,
  `${CDN}/vzjehykz_Screenshot%202026-05-19%20at%209.53.55%E2%80%AFPM.png`,
  `${CDN}/jkkjuac2_22B57F64-D23D-46EB-8C13-DE023BD13ADD.jpeg`,
  `${CDN}/uj0mk81s_IMG_9772.jpeg`,
  `${CDN}/ywwb7x9d_IMG_9741.jpg`,
  `${CDN}/82nhytqh_IMG_8127.jpg`,
];

export const ARTIST_NAMES = [
  "RAFTAAR",
  "IKKA",
  "KARMA",
  "DIVINE",
  "SEEDHE MAUT",
  "RAJA KUMARI",
];

/** Map a Supabase row to the UI product shape. */
export function normalizeProduct(row) {
  if (!row) return null;
  return {
    id: row.id,
    name: row.name,
    description: row.description || row.short_description || "",
    materials: row.materials || "",
    category: (row.category || "").toUpperCase(), // "STAPLE" | "EXCLUSIVE"
    priceInr: Number(row.price_inr),
    sku: row.sku,
    stockQty: Number(row.stock_qty ?? 0),
    sizes: row.sizes || SIZES,
    images: row.images || [],
    videos: row.videos || [],
    tags: row.tags || [],
    featured: !!row.featured,
  };
}

export function filterProducts({ category, tag } = {}, list = []) {
  return list.filter((p) => {
    if (category && category !== "all") {
      if (category === "staples" && p.category !== "STAPLE") return false;
      if (category === "exclusives" && p.category !== "EXCLUSIVE") return false;
    }
    if (tag && tag !== "all") {
      if (!(p.tags || []).includes(tag)) return false;
    }
    return true;
  });
}

export function findProduct(id, list = []) {
  return list.find((p) => p.id === id) || null;
}
